import { pageViewTypes } from "@constants/tracking";
import { HomeRouteContainer, StudyPackContainer } from "@features/dashboard/";
import useAnalytics from "@hooks/useAnalytics";
/* -----------------Globals--------------- */
import { useAppStore } from "@hooks/useAppStore";
import { useGlobalStore } from "@hooks/useGlobalStore";
import DocumentTitle from "components/DocumentTitle";
import { useFocusEffect } from "expo-router";
import { useCallback } from "react";

/* -----------------Child components--------------- */

const StudyPackRouteContainer = () => {
	return (
		<>
			<DocumentTitle title="Study-Pack" />
			<StudyPackContainer showBackButton={false} />
		</>
	);
};
const HomeRoute = () => {
	const showStudyPackAsHome = useAppStore((store) => store.showStudyPackAsHome);
	const setHasShownConfidenceOnboardingDialog = useGlobalStore(
		(state) => state.setHasShownConfidenceOnboardingDialog,
	);

	useFocusEffect(
		useCallback(() => {
			setHasShownConfidenceOnboardingDialog(false);
		}, [setHasShownConfidenceOnboardingDialog]),
	);

	useAnalytics({
		type: pageViewTypes.home,
	});

	if (showStudyPackAsHome) {
		return <StudyPackRouteContainer />;
	}
	return (
		<>
			<DocumentTitle title="Home" />
			<HomeRouteContainer />
		</>
	);
};

export default HomeRoute;
